import { render, staticRenderFns } from "./ListItemsController.vue?vue&type=template&id=3ab0aa64&scoped=true"
import script from "./ListItemsController.vue?vue&type=script&lang=js"
export * from "./ListItemsController.vue?vue&type=script&lang=js"
import style0 from "./ListItemsController.vue?vue&type=style&index=0&id=3ab0aa64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab0aa64",
  null
  
)

export default component.exports